export default {
  navigation: {
    sections: {
      platform: 'Plateforme',
      moderation: 'Modération',
      website: 'Site web',
      configuration: 'Configuration',
      administration: 'Administration',
    },
    jobs: 'Projets',
    industries: 'Domaines',
    cities: 'Villes',
    profiles: 'Utilisateurs',
    notifications: 'Notifications',
    reports: 'Signalements',
    services: 'Services',
    dashboard: 'Tableau de bord',
    projects: 'Projets',
    quotes: 'Soumissions',
    reviews: 'Evaluations',
    settings: 'Paramètres',
    freelancers: 'Pigistes',
    recruiters: 'Recruteurs',
    create: 'Ajouter un administrateur',
    blog: 'Blog',
    articles: 'Articles',
    websiteMedia: 'Medias du site',
    websiteContent: 'Contenu du site',
    serviceCatalog: 'Catalogue de services',
    campaigns: 'Campagnes',
    categories: 'Catégories',
    tags: 'Mots-clés',
    creditGifts: 'Crédits offerts',
    credits: 'Crédits',
    creditTransactions: 'Transactions de crédits',
    userLookup: 'Trouver un utilisateur',
  },
  creditGift: {
    title: 'Offrir des crédits',
    giftCredits: 'Offrir des crédits',
    recipient: 'Bénéficiaire',
    amount: 'Montant',
    reasonOptional: 'Raison (optionnel)',
    submit: 'Offrir les crédits',
    success: 'Crédits offerts avec succès',
    invalidAmount: 'Le montant doit être positif',
  },
  creditGiftConfig: {
    title: 'Crédits offerts',
    subtitle:
      'Choisissez une option : crédits à l’inscription ou crédits mensuels. Elles ne peuvent pas être actives en même temps.',
    modeLabel: 'Offre automatique de crédits',
    modeOff: 'Désactivé',
    modeSignup: 'Crédits à l’inscription',
    modeMonthly: 'Crédits mensuels',
    signupAmounts: 'Crédits à l’inscription (par rôle)',
    monthlyAmounts: 'Crédits mensuels (par rôle)',
    monthlyObnlLabel: 'Organisation (OBNL)',
    monthlyCumulative:
      'Cumulatif (les crédits non utilisés sont reportés). Si décoché, le solde est réinitialisé chaque mois.',
    save: 'Enregistrer',
    saved: 'Configuration enregistrée',
    invalidAmounts: 'Les montants doivent être 0 ou plus',
  },
  creditTransactions: {
    title: 'Transactions de crédits',
    availableCredits: 'Crédits disponibles',
    viewUserTransactions: 'Voir les transactions de crédits',
    filteredByUser: 'Filtré pour :',
    filteredByUserFallback: 'Utilisateur sélectionné',
    clearUserFilter: 'Retirer le filtre utilisateur',
    userSearch: 'Rechercher un utilisateur',
    searchPlaceholder: 'Nom ou courriel',
    type: 'Type',
    period: 'Période',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    periodPresets: {
      all: 'Toute la période',
      lastWeek: 'La dernière semaine',
      lastMonth: 'Le dernier mois',
      lastQuarter: 'Le dernier trimestre',
      custom: 'Personnalisée',
    },
    columns: {
      date: 'Date',
      user: 'Utilisateur',
      reason: 'Raison',
      type: 'Type',
      amount: 'Montant',
      balance: 'Solde',
    },
    actionTypes: {
      purchase: 'Achat de crédits',
      refund: 'Remboursement',
      admin_adjustment: 'Ajustement administratif',
      signup_gift: 'Crédits offerts à l’inscription',
      monthly_gift: 'Crédits offerts mensuels',
      send_alliance_request: 'Envoi d’une demande d’alliance',
      accept_quote_request: 'Acceptation d’une demande de soumission',
      accept_quote_alliance_request: 'Acceptation d’une demande de soumission en alliance',
      submit_public_job_quote: 'Soumission à un projet public',
      publish_job_standard: 'Publication d’un projet standard',
      publish_job_featured: 'Publication d’un projet vedette',
      publish_job_urgent: 'Publication d’un projet urgent',
    },
  },
  table_fields: {
    title: 'Titre',
    description: 'Description',
    on_site: 'Sur site',
    languages: 'Langues',
    start_date: 'Date de début',
    end_date: 'Date de fin',
    status: 'Statut',
    visibility: 'Visibilité',
    published_at: 'Publié le',
    expires_at: 'Date limite de soumission',
    selection_date: 'Date de réponse prévue',
    created_at: 'Créé le',
    updated_at: 'Mis à jour le',
    completed_at: 'Terminé le',
    budget_range: 'Budget',
    client: 'Client',
    city: 'Ville',
    listing_type: 'Type d’annonce',
    service_category: 'Catégorie de service',
    is_active: 'Actif',
    first_name: 'Prénom',
    last_name: 'Nom',
    phone: 'Téléphone',
    is_remote: 'À distance',
    postal: 'Code postal',
    role: 'Rôle',
    company_type: 'Type d’entreprise',
    company_name: 'Nom de l’entreprise',
    job_title: 'Intitulé du poste',
    organization_website: "Site web de l'organisation",
    organization_number: "Numéro de l'organisation",
    obnl_review_status: 'Statut OBNL',
    avatar_url: 'Photo de profil',
    slug: 'Identifiant',
    label: 'Titre',
    label_fr: 'Titre (français)',
    label_en: 'Titre (anglais)',
    name: 'Nom',
    code: 'Code',
    latitude: 'Latitude',
    longitude: 'Longitude',
    reporter: 'Auteur du signalement',
    reporter_email: 'Courriel',
    reported: 'Signalé',
    content_type: 'Type de contenu',
    reported_content: 'Objet de signalement',
    entity: 'Entité',
    reason: 'Raison',
    details: 'Détails',
    admin_notes: 'Notes administrateur',
    resolved_at: 'Résolu le',
    reviewer: 'Évaluateur',
    reviewed: 'Évalué',
    quote: 'Devis',
    rating: 'Évaluation',
    comment: 'Commentaire',
    validated: 'validé',
    destination_profile: 'Destinataire',
    source_profile: 'Auteur',
    payload: 'Données associées',
    read_at: 'Lu le',
    email_sent: 'Email envoyé',
    suggested_by: 'proposé par',
    user: 'Utilisateur',
    company: 'Entreprise',
    owner: 'Auteur',
    type: 'Type',
    actions: 'Actions',
    deleted: 'Supprimé',
  },
  common: {
    search: 'Rechercher...',
    cancel: 'Annuler',
    submit: 'Envoyer',
  },
  obnlReview: {
    approve: 'Approuver OBNL',
    reject: 'Refuser OBNL',
    approvedSuccess: 'Le statut OBNL a été approuvé avec succès',
    rejectedSuccess: 'Le statut OBNL a été refusé avec succès',
    error: 'Impossible de mettre à jour le statut OBNL.',
  },
  deleteUser: {
    deleteButton: "Supprimer l'utilisateur",
    title: "Supprimer l'utilisateur",
    warning:
      'Vous êtes sur le point de supprimer définitivement {{username}}. Ses informations personnelles seront effacées et il ou elle ne pourra plus se connecter. Cette action est irréversible.',
    confirmPrompt: 'Tapez {{word}} pour confirmer',
    confirmWord: 'SUPPRIMER',
    confirmButton: "Supprimer l'utilisateur",
    success: 'Utilisateur supprimé avec succès',
    error: 'Impossible de supprimer cet utilisateur.',
  },
  generateAuthLink: {
    buttonTooltip: 'Générer un lien de connexion',
    title: 'Générer un lien de connexion',
    loading: 'Génération du lien en cours...',
    magiclinkHelp: 'Ce lien permet à l’utilisateur de confirmer son compte et de se connecter.',
    recoveryHelp: 'Ce lien permet à l’utilisateur de définir un nouveau mot de passe.',
    copyButton: 'Copier le lien',
    copied: 'Lien copié',
    copyError: 'Impossible de copier ce lien.',
    error: 'Impossible de générer un lien pour cet utilisateur.',
  },
  userLookup: {
    title: 'Trouver un utilisateur',
    emailLabel: 'Courriel',
    emailPlaceholder: 'nom@exemple.com',
    searchButton: 'Rechercher',
    notFound: 'Aucun utilisateur trouvé avec ce courriel.',
    confirmed: 'Confirmé',
    unconfirmed: 'Non confirmé',
    generateLinkButton: 'Générer un lien',
    error: 'Impossible de trouver cet utilisateur.',
  },
  search_cities: 'Rechercher des villes',
  search_cities_placeholder: 'Rechercher par nom ou code…',
  cities_no_search_results: 'Aucune ville ne correspond à cette recherche.',
  cities_empty: 'Aucune ville dans la base pour le moment.',
  city_code_hint:
    'Utilisez le code de la municipalité régionale (p. ex. 10) correspondant au jeu de données du Ministère des Affaires municipales. La paire nom + code doit être unique.',
  invalid_number: 'Entrez un nombre valide ou laissez vide.',
  cancel_this_job: 'Annuler ce projet',
  cancel_this_hint: 'Cette action est irréversible. Le projet sera annulé de la plateforme.',
  manage_review: "Gestion de l'évaluation",
  view_all_users: 'Voir tous les utilisateurs',
  recent_users: 'Utilisateurs récents',
  user_search_label: 'Rechercher des utilisateurs',
  user_search_placeholder: 'Nom, courriel, téléphone ou entreprise...',
  userActivity: {
    title: "Activité de l'utilisateur",
    quotes: 'Soumissions',
    projects: 'Projets',
    jobs: "Offres d'emploi",
    empty: 'Aucune activité à afficher.',
    loadError: "Impossible de charger l'activité de cet utilisateur.",
    quotesCount_one: '{{count}} soumission',
    quotesCount_other: '{{count}} soumissions',
  },
  add_admin: 'Ajouter un administrateur',
  create_admin_success: "L'administrateur a été créé avec succès",
  edit_industry: 'Modifier le domaine',
  edit_service_category: 'Modifier la catégorie de service',
  industry_details: 'Détails du domaine',
  service_category_details: 'Détails du service',
  blogAdmin: {
    new_post: 'Nouvel article',
    edit_post: "Modifier l'article",
    title: 'Titre',
    slug: 'Slug',
    content: 'Contenu',
    excerpt: 'Extrait',
    category: 'Catégorie',
    categories: 'Catégories',
    tags: 'Mots-clés',
    status: 'Statut',
    published_at: 'Publié le',
    featured_image: 'Image à la une',
    seo_ia: 'SEO & IA',
    seo_title: 'Méta Titre',
    seo_description: 'Méta Description',
    ai_summary: 'Résumé pour IA',
    save: 'Sauvegarder',
    saving: 'Sauvegarde en cours...',
    delete: 'Supprimer',
    cancel: 'Annuler',
    upload_image: 'Cliquez pour téléverser',
    scheduled_at: 'Planifié pour',
    scheduled: 'Planifié',
    author: 'Auteur',
    select_author: 'Sélectionner un auteur',
    you_are_selected: 'Vous (par défaut)',
    writing_guide_title: 'Rédiger un bon article',
    writing_guide_text:
      "Utilisez un titre clair, des titres structurés (H2, H3) et des mots-clés pour un meilleur SEO et indexation IA. Une image de qualité augmente l'engagement.",
    blog_logic: 'Édition avancée et structurée',
    title_placeholder: 'Saisissez votre titre ici',
    excerpt_placeholder: "Court résumé de l'article pour les listes...",
    seo_hint: "Aperçu Google et résumé pour l'IA",
    ai_summary_placeholder:
      'Rédigez ici un résumé ultra-optimisé pour les moteurs de recherche IA...',
    category_name_prompt: 'Nom de la nouvelle catégorie :',
    add_tag: 'Rechercher ou ajouter un mot-clé...',
    required_fields: "Le titre et l'identifiant (slug) sont requis",
    update_success: 'Article mis à jour avec succès',
    create_success: 'Article créé avec succès',
    save_error: 'Erreur lors de la sauvegarde',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet article ?',
    delete_success: 'Article supprimé',
    image_upload_success: 'Image téléversée avec succès',
    image_upload_error: "Erreur lors du téléchargement de l'image",
    uploading_image: "Téléchargement de l'image en cours...",
    uploading: 'Téléchargement...',
    category_created: 'Catégorie créée avec succès',
    tag_created: 'Mot-clé créé avec succès',
    create_category: 'Créer une catégorie',
    create_tag: 'Créer un mot-clé',
    required_size: 'Taille recommandée : 1200x630px',
    max_chars: 'Limite recommandée :',
    title_limit: '70 caractères',
    slug_limit: 'Le slug doit être adapté aux URLs',
    preview_label: 'Aperçu',
    preview_edit: 'Édition',
    preview_split: 'Partagé',
    preview_only: 'Aperçu seul',
    preview_empty_title: 'Titre de l’article',
    preview_empty_excerpt: 'L’extrait apparaîtra ici dès qu’il sera ajouté.',
    preview_empty_content: 'Le contenu rédigé dans l’éditeur sera prévisualisé ici.',
    go_to_preview: 'Voir l’aperçu sur le site',
    go_to_preview_hint:
      'Ouvre l’article sur le site public en mode aperçu. Connectez-vous avec un compte admin si nécessaire.',
    language_section: 'Langue',
    edit_other_locale: 'Modifier la version {{locale}}',
    create_other_locale: 'Créer la version {{locale}}',
    filter_all_status: 'Tous les statuts',
    filter_all_locales: 'Toutes les langues',
    filter_locale_fr: 'Français seulement',
    filter_locale_en: 'Anglais seulement',
    locale_column: 'Lang.',
    image_library: 'Bibliothèque média',
    image_library_hint:
      'Images déjà téléversées pour le blog (même dossier que les nouveaux fichiers).',
    image_library_empty:
      'Aucune image pour l’instant. Téléversez une image depuis l’éditeur ou l’image à la une.',
    choose_from_library: 'Choisir dans la bibliothèque',
    insert_image_upload: 'Téléverser une nouvelle image',
    insert_image_library: 'Insérer une image de la bibliothèque',
    manage_posts_subtitle: 'Gérez et publiez vos articles de blog',
    no_posts_title: 'Aucun article pour le moment',
    no_posts_hint: 'Commencez par créer votre premier article !',
    name: 'Nom',
    description: 'Description',
    add: 'Ajouter',
    update: 'Mettre à jour',
    edit_category: 'Modifier la catégorie',
    manage_categories_hint: 'Créez et gérez les catégories pour organiser vos articles.',
    category_updated: 'Catégorie mise à jour avec succès',
    confirm_delete_category: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
    category_deleted: 'Catégorie supprimée avec succès',
    edit_tag: 'Modifier le mot-clé',
    manage_tags_hint: 'Créez et gérez les mots-clés pour organiser vos articles.',
    tag_updated: 'Mot-clé mis à jour avec succès',
    confirm_delete_tag: 'Êtes-vous sûr de vouloir supprimer ce mot-clé ?',
    tag_deleted: 'Mot-clé supprimé avec succès',
    confirm_delete_category_hint:
      "Voulez-vous vraiment supprimer cette catégorie ? Les articles associés ne seront pas supprimés mais n'auront plus cette catégorie.",
    confirm_delete_tag_hint: 'Voulez-vous vraiment supprimer ce mot-clé ?',
    confirm_delete_hint: "Cette action est irréversible. L'article sera définitivement supprimé.",
    enter_link_url: 'Entrer l’URL du lien',
    insert_link: 'Insérer un lien',
    enter_iframe_url: 'Entrez l’URL d’intégration iframe autorisée (src de l’iframe)',
    enter_iframe_title: 'Entrez un titre descriptif pour cette intégration (pour l’accessibilité)',
    default_iframe_title: 'Contenu intégré',
    insert_iframe: 'Insérer une iframe',
    iframe_untrusted_origin:
      "Cette origine iframe n'est pas autorisée. Utilisez une URL d’intégration https provenant d’une origine approuvée.",
    iframe_not_embeddable:
      "Cette URL n'est pas un lien intégrable. Utilisez l’URL d’intégration fournie par le service (par exemple /embed/... pour YouTube, /video/... pour Vimeo).",
    iframe_allowlist_empty:
      'Les intégrations iframe sont désactivées. Configurez d’abord les origines autorisées.',
  },
  websiteMedia: {
    title: 'Medias du site',
    subtitle:
      'Gerez les photos marketing et les images de secours utilisees sur le site public. Les logos de marque et les SVG decoratifs restent dans le code.',
    upload: 'Televerser une image',
    clear: 'Retirer la surcharge',
    save: 'Enregistrer les changements',
    saving: 'Enregistrement...',
    image_uploaded: 'Image televersee avec succes',
    image_upload_error: "Erreur lors du televersement de l'image",
    save_success: 'Medias du site sauvegardes avec succes',
    save_error: 'Erreur lors de la sauvegarde des medias',
    clear_success: "La surcharge a ete retiree. Le site reutilise maintenant l'image par defaut.",
    clear_error: 'Erreur lors de la suppression de la surcharge',
    override_active: 'Surcharge active',
    using_default: 'Image par defaut',
    shared_locale_hint:
      'Les images sont partagees entre le FR et le EN. Les textes alternatifs sont localises par langue.',
    alt_hint:
      "Utilisez un texte alternatif court et descriptif pour garder l'image accessible apres remplacement.",
    unknown_error: 'Erreur inconnue',
    fields: {
      image_url: "URL de l'image",
      alt_text_fr: 'Texte alternatif FR',
      alt_text_en: 'Texte alternatif EN',
    },
    pages: {
      home: 'Page accueil',
      about: 'Page a propos',
      resources: 'Page ressources',
    },
    sections: {
      home: {
        testimonials: 'Temoignages',
        features: 'Cartes vedettes',
        pricing: 'Bloc tarification',
      },
      about: {
        belief: 'Section conviction',
        alliances: 'Section alliances',
        village_marquee: 'Carrousel village',
        village_scroll: 'Tuiles defilantes',
      },
      resources: {
        fallbacks: 'Images de secours',
      },
    },
    placements: {
      home_testimonial_1: 'Temoignage 1',
      home_testimonial_2: 'Temoignage 2',
      home_testimonial_3: 'Temoignage 3',
      home_testimonial_4: 'Temoignage 4',
      home_feature_1: 'Carte vedette 1',
      home_feature_2: 'Carte vedette 2',
      home_feature_3: 'Carte vedette 3',
      home_pricing_photo: 'Photo tarification',
      about_belief_photo: 'Photo conviction',
      about_alliances_background: 'Arriere-plan alliances',
      about_village_marquee_1: 'Image carrousel 1',
      about_village_marquee_2: 'Image carrousel 2',
      about_village_marquee_3: 'Image carrousel 3',
      about_village_marquee_4: 'Image carrousel 4',
      about_village_scroll_1: 'Image tuile 1',
      about_village_scroll_2: 'Image tuile 2',
      about_village_scroll_3: 'Image tuile 3',
      resources_featured_fallback: 'Secours article vedette',
      resources_freelancer_fallback: 'Secours section pigistes',
      resources_recruiter_fallback: 'Secours section recruteurs',
      resources_other_fallback: 'Secours autres ressources',
    },
  },
  websiteContent: {
    title: 'Contenu du site',
    subtitle: 'Choisissez une page pour gerer ses photos.',
    back_to_pages: 'Retour aux pages',
    photo_count_one: '{{count}} photo',
    photo_count_other: '{{count}} photos',
    upload: 'Televerser une image',
    choose_from_library: 'Choisir dans la bibliotheque',
    image_library: 'Bibliotheque medias du site',
    image_library_hint: 'Images deja televersees pour cette page.',
    image_library_empty:
      'Aucune image pour l instant. Televersez une image dabord, puis vous pourrez la reutiliser ici.',
    image_selected: 'Image appliquee',
    clear: 'Retirer la surcharge',
    save: 'Enregistrer les changements',
    saving: 'Enregistrement...',
    image_uploaded: 'Image televersee avec succes',
    image_upload_error: "Erreur lors du televersement de l'image",
    save_success: 'Contenu du site sauvegarde avec succes',
    save_error: 'Erreur lors de la sauvegarde du contenu du site',
    invalid_image_host:
      "L'hote de cette URL d'image n'est pas autorise. Utilisez le televersement ou la bibliotheque, ou collez une URL provenant d'un hote autorise.",
    clear_success: "La surcharge a ete retiree. Le site reutilise maintenant l'image par defaut.",
    clear_error: 'Erreur lors de la suppression de la surcharge',
    override_active: 'Surcharge active',
    using_default: 'Image par defaut',
    shared_locale_hint:
      'Les images sont partagees entre le FR et le EN. Les textes alternatifs sont localises par langue.',
    unknown_error: 'Erreur inconnue',
    no_image: "Aucune image pour l'instant",
    fields: {
      image_url: "URL de l'image",
      alt_text_fr: 'Texte alternatif FR',
      alt_text_en: 'Texte alternatif EN',
    },
    pages: {
      global: 'Global',
      home: 'Page accueil',
      about: 'Page a propos',
      services: 'Page services',
      resources: 'Page ressources',
      pricing: 'Page tarification',
    },
    sections: {
      global: {
        social_share: 'Partage social',
      },
      home: {
        avatars: 'Photos des pigistes',
        photos: 'Photos',
      },
      about: {
        photos: 'Photos',
      },
      services: {
        hero: 'Bloc hero',
      },
      resources: {
        fallbacks: 'Images de secours',
      },
      pricing: {
        hero: 'Bloc hero',
      },
    },
    placements: {
      home_freelancer_avatar_1: 'Photo 1',
      home_freelancer_avatar_2: 'Photo 2',
      home_freelancer_avatar_3: 'Photo 3',
      home_freelancer_avatar_4: 'Photo 4',
      home_freelancer_avatar_5: 'Photo 5',
      home_freelancer_avatar_6: 'Photo 6',
      about_photo_1: '1re photo',
      about_photo_2: '2e photo',
      about_photo_3: '3e photo',
      home_dashboard_photo: 'Capture du tableau de bord',
      home_guide_pigistes_photo: 'Photo du guide pigistes',
      home_guide_recruteurs_photo: 'Photo du guide recruteurs',
      home_feature_pigistes_photo: 'Carte fonctionnalité : pigistes',
      home_feature_annonces_photo: 'Carte fonctionnalité : annonces',
      home_feature_alliances_photo: 'Carte fonctionnalité : alliances',
      services_hero_photo: 'Photo hero',
      resources_featured_fallback: 'Secours article vedette',
      resources_freelancer_fallback: 'Secours section pigistes',
      resources_recruiter_fallback: 'Secours section recruteurs',
      resources_other_fallback: 'Secours autres ressources',
      pricing_hero_photo: 'Photo hero tarification',
      social_share_image: 'Image de partage social (1200 x 630 px recommandé)',
    },
  },
  jobActivityHub: {
    title: 'Hub d’activité du projet',
    fallback_title: 'Projet',
    back_to_jobs: 'Retour aux projets',
    refresh: 'Actualiser',
    invalid_job: 'Identifiant de projet manquant.',
    unread_section: 'Notifications vues / non lues (par participant)',
    unread_help:
      'Les non lus comptent les notifications in-app dont le contenu référence ce projet (ex. messages du hub et alertes).',
    no_participants: 'Aucun participant trouvé pour ce projet.',
    unread_count: '{{count}} non lues',
    all_seen: 'Tout lu',
    no_hub_threads:
      'Aucune vue hub recruteur disponible pour l’instant (par exemple, projet public sans soumissions).',
    perspective_label: 'Vue',
    perspective_help:
      'Basculez entre la boîte recruteur (client) et le hub du pigiste principal pour voir les échanges client ↔ pigiste ou pigiste ↔ alliances.',
    perspective_recruiter: 'Recruteur (client)',
    perspective_freelancer: 'Pigiste principal',
    principal_offer_label: 'Offre principale',
    dashboard_section_title: 'Projets récents — hub d’activité',
    dashboard_section_subtitle: 'Ouvrir le hub d’activité en lecture seule pour un projet récent.',
    view_all_jobs: 'Tous les projets',
    no_recent_jobs: 'Aucun projet trouvé.',
    open_hub: 'Ouvrir le hub d’activité',
    open_hub_short: 'Hub',
    actions_column: 'Activité',
    view_details: 'Voir les détails du projet',
    details_load_error: 'Impossible de charger les détails du projet. Veuillez réessayer.',
  },
  status: {
    draft: 'Brouillon',
    published: 'Publié',
    scheduled: 'Planifié',
  },
  serviceCatalog: {
    title: 'Catalogue de services',
    subtitle:
      'Gérez les services proposés, les types de pigistes associés et le chatbot de capture de leads.',
    tabs: {
      items: 'Services',
      freelancerTypes: 'Types de pigistes',
      leads: 'Leads',
    },
    itemsSubtitle: 'Les services affichés dans le catalogue public.',
    addItem: 'Ajouter un service',
    addFreelancerType: 'Ajouter un type',
    addBenefitTag: 'Ajouter un avantage',
    addOption: 'Ajouter une option',
    deleteQuestion: 'Supprimer la question',
    itemCreated: 'Service créé',
    saveSuccess: 'Enregistré',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    confirmDelete: 'Voulez-vous vraiment supprimer cet élément ?',
    genericError: 'Une erreur est survenue',
    deactivateToEditQuestions:
      "Désactivez ce service avant d'ajouter une nouvelle question — une question fraîchement ajoutée n'a pas encore d'options et bloquerait aussitôt le chatbot en direct.",
    active: 'Actif',
    inactive: 'Inactif',
    noLeads: 'Aucun lead pour le moment.',
    fields: {
      active: 'Actif',
      slug: 'Slug',
      nameFr: 'Nom (FR)',
      nameEn: 'Nom (EN)',
      categoryFr: 'Catégorie (FR)',
      categoryEn: 'Catégorie (EN)',
      shortDescriptionFr: 'Description courte (FR)',
      shortDescriptionEn: 'Description courte (EN)',
      fullDescriptionFr: 'Description complète (FR)',
      fullDescriptionEn: 'Description complète (EN)',
      chatbotGreetingFr: 'Message d’accueil du chatbot (FR)',
      chatbotGreetingEn: 'Message d’accueil du chatbot (EN)',
      chatbotIntroFr: 'Introduction du chatbot (FR)',
      chatbotIntroEn: 'Introduction du chatbot (EN)',
      freelancerTypes: 'Types de pigistes associés',
      benefitTags: 'Avantages ("Ce service est fait pour")',
      chatbotQuestions: 'Questions du chatbot',
      labelFr: 'Libellé (FR)',
      labelEn: 'Libellé (EN)',
      questionTextFr: 'Question (FR)',
      questionTextEn: 'Question (EN)',
      placeholderFr: 'Placeholder (FR)',
      placeholderEn: 'Placeholder (EN)',
      optional: 'Facultatif (bouton Passer)',
      gotoNext: 'Étape suivante (par défaut)',
      createdAt: 'Reçu le',
      serviceName: 'Service',
      email: 'Courriel',
      phone: 'Téléphone',
      locale: 'Langue',
      status: 'Statut',
      answers: 'Réponses',
    },
    stepTypes: {
      text: 'Texte libre',
      choice: 'Choix multiples',
      contact: 'Coordonnées',
    },
    leadStatus: {
      new: 'Nouveau',
      contacted: 'Contacté',
      closed: 'Fermé',
    },
  },
  loading: 'Chargement...',
  loadMore: 'Charger plus',
  create_admin: 'Ajouter un administrateur',
  city: 'Ville',
  phone: 'Téléphone',
  email: 'Courriel',
  informations: 'Informations',
  allServicesTitle: 'Tous les services',
  pendingServicesTitle: 'Services en attente',
  pendingServicesEmpty: 'Aucun service en attente',
  industryDeleted: 'Secteur supprimé',
  industryDeleteError: 'Échec de la suppression du secteur',
  serviceCategoryDeleted: 'Catégorie de service supprimée',
  serviceCategoryDeleteError: 'Échec de la suppression de la catégorie',
  service_category_label_hint:
    'Le titre français est obligatoire. Les traductions par slug restent affichées tant que le français et l’anglais ne sont pas tous les deux renseignés.',
  serviceCategoryUpdateError: 'Échec de la mise à jour de la catégorie de service',
  job_status: {
    open: 'Ouvert',
    in_progress: 'En cours',
    completed: 'Terminé',
    cancelled: 'Annulé',
    paused: 'En pause',
    expired: 'Expirée',
    reviewing_quotes: 'En révision des soumissions',
  },
  jobModeration: {
    editTitle: 'Modifier le projet',
    editSubtitle:
      'Les modifications seront enregistrées et le recruteur sera notifié avec votre motif.',
    editButton: 'Modifier le projet',
    createButton: 'Créer une offre',
    createSuccess: 'Offre créée avec succès.',
    createRefreshError:
      "L'offre a été créée, mais la liste n'a pas pu être actualisée. Veuillez recharger la page.",
    unpublishButton: 'Dépublier',
    pauseButton: 'Mettre en pause',
    unpublishTitle: 'Dépublier le projet',
    pauseTitle: 'Mettre le projet en pause',
    unpublishExplanation:
      "Ce projet n'a pas de soumissions. Il sera retiré du babillard et remis en brouillon (ou annulé s'il est privé).",
    pauseExplanation:
      'Ce projet a des soumissions. Il sera mis en pause pour protéger les candidats pendant que vous résolvez le problème.',
    reasonLabel: 'Motif pour le recruteur',
    reasonPlaceholder: 'Expliquez ce qui s’est passé et pourquoi cette action a été prise…',
    reasonRequired: 'Veuillez fournir un motif d’au moins {{min}} caractères.',
    reasonTooShort: 'Le motif doit contenir au moins {{min}} caractères.',
    confirmEdit: 'Enregistrer les modifications',
    confirmUnpublish: 'Dépublier le projet',
    confirmPause: 'Mettre en pause',
    editSuccess: 'Projet mis à jour et recruteur notifié.',
    unpublishSuccess: 'Projet dépublié et recruteur notifié.',
    pauseSuccess: 'Projet mis en pause et recruteur notifié.',
    noCreditRefund:
      'Les crédits de publication ne sont pas remboursés lorsqu’un administrateur dépublie un projet.',
    quotesCount: 'Soumissions',
    allPublications: 'Toutes les publications',
    publication: {
      draft: 'Brouillon',
      published: 'Publié',
      private: 'Privé',
    },
    forceNotifyButton: 'Notifier les pigistes correspondants',
    forceNotifySuccess_one: '{{count}} pigiste notifié.',
    forceNotifySuccess_other: '{{count}} pigistes notifiés.',
    forceNotifyNoMatches: 'Aucun pigiste correspondant à notifier.',
    forceNotifyError: "Ce projet n'est pas éligible à la notification, ou une erreur est survenue.",
    publishButton: 'Publier',
    publishTitle: 'Publier le projet',
    publishExplanation:
      "Ce projet a été créé au nom d'un recruteur fantôme. Choisissez une priorité d'affichage et une date limite de soumission pour le rendre visible sur le babillard.",
    publishNoCredits: "Cette action n'utilise ni ne consomme aucun crédit.",
    publishListingTypeLabel: "Priorité d'affichage",
    publishExpiresAtLabel: 'Date limite de soumission',
    confirmPublish: 'Publier le projet',
    publishSuccess: 'Projet publié.',
    publishRefreshError:
      "Le projet a été publié, mais nous n'avons pas pu actualiser la liste. Veuillez recharger la page.",
    publishListingTypesLoadError: "Impossible de charger les priorités d'affichage.",
    publishRetry: 'Réessayer',
    publishErrorNotShadowJob:
      'Seuls les projets fantômes non réclamés peuvent être publiés de cette façon.',
    publishErrorNotPublishable: "Ce projet n'est pas dans un état publiable.",
    publishErrorAlreadyPublished: 'Ce projet est déjà publié.',
    assignToRecruiterButton: 'Assigner à un recruteur existant',
    assignTitle: 'Assigner à un recruteur existant',
    assignExplanation:
      'Cette action transfère la propriété du projet directement à un compte recruteur existant et retire toute mention « Pigeons au nom de… ».',
    assignSearchLabel: 'Rechercher des recruteurs',
    assignSearchPlaceholder: 'Rechercher par nom, courriel ou entreprise…',
    assignNoResults: 'Aucun recruteur actif trouvé.',
    assignSearchError: 'Impossible de rechercher les recruteurs. Réessayez.',
    confirmAssign: 'Assigner le projet',
    assignSuccess: 'Projet assigné au recruteur.',
    assignRefreshError:
      "Le projet a été assigné, mais nous n'avons pas pu actualiser la liste. Veuillez recharger la page.",
    assignErrorNotAssignable:
      'Seuls les projets appartenant à Pigeons ou à un recruteur fantôme non réclamé peuvent être assignés de cette façon.',
    assignErrorNotEligible: "Ce compte n'est pas un recruteur actif.",
    assignErrorHasQuoteActivity:
      'Ce projet a déjà des demandes de soumission et ne peut pas être transféré de cette façon.',
    assignErrorAdminNotActive: "Votre compte administrateur n'est pas actif.",
  },
  shadowRecruiters: {
    assignRejected:
      "Rien n'a été enregistré : {{jobs}} appartiennent déjà à un autre recruteur et ne peuvent pas être associés à ce recruteur fantôme.",
    alreadyClaimed:
      'Ce recruteur fantôme a déjà réclamé son compte. Actualisez la page pour voir les dernières informations.',
  },
  campaigns: {
    title: 'Campagnes',
    subtitle:
      'Créez et modifiez les pages d’atterrissage pour les campagnes publicitaires ciblées.',
    add_item: 'Nouvelle campagne',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    delete: 'Supprimer',
    confirm_delete_item: 'Voulez-vous vraiment supprimer cette campagne ?',
    save_success: 'Campagne enregistrée avec succès',
    save_error: 'Erreur lors de l’enregistrement de la campagne',
    delete_error: 'Erreur lors de la suppression de la campagne',
    create_error: 'Erreur lors de la création de la campagne',
    unknown_error: 'Erreur inconnue',
    upload: 'Téléverser une image',
    choose_from_library: 'Choisir dans la bibliothèque',
    image_uploaded: 'Image téléversée avec succès',
    image_upload_error: 'Erreur lors du téléversement de l’image',
    no_image: 'Aucune image',
    published: 'Publiée',
    unpublished: 'Non publiée',
    preview_url: 'URL publique',
    view_leads: 'Voir les prospects',
    refresh: 'Actualiser',
    leads_title: 'Prospects',
    leads_empty: 'Aucun prospect pour cette campagne pour le moment.',
    leads_error: 'Erreur lors du chargement des prospects',
    fields: {
      slug: 'Identifiant (slug)',
      slug_hint: 'Utilisé dans l’URL, ex. /campaigns/photographes-montreal',
      profession: 'Profession',
      badge_fr: 'Badge en français',
      badge_en: 'Badge en anglais',
      headline_fr: 'Titre en français',
      headline_en: 'Titre en anglais',
      subheadline_fr: 'Sous-titre en français',
      subheadline_en: 'Sous-titre en anglais',
      hero_image: 'Image principale',
      hero_image_alt_fr: 'Texte alternatif (français) de l’image principale',
      hero_image_alt_en: 'Texte alternatif (anglais) de l’image principale',
      benefit_fr: 'Avantage {{order}} (français)',
      benefit_en: 'Avantage {{order}} (anglais)',
      gallery: 'Images de la galerie',
      cta_text_fr: 'Texte du bouton (français)',
      cta_text_en: 'Texte du bouton (anglais)',
    },
    leads_fields: {
      name: 'Nom',
      email: 'Courriel',
      phone: 'Téléphone',
      created_at: 'Soumis le',
    },
  },
} as const;
